import type { ColDef, FilterModel } from "~/components/grid/AgGrid";

interface MultiFilterSlot {
	filter?: string;
}

const isAlreadyMultiShaped = (entry: unknown): boolean =>
	!!entry && typeof entry === "object" && (entry as { filterType?: unknown }).filterType === "multi";

const isSetShaped = (entry: unknown): boolean =>
	!!entry && typeof entry === "object" && Array.isArray((entry as { values?: unknown }).values);

const multiFilterSlots = (colDef: ColDef | undefined): MultiFilterSlot[] | undefined => {
	if (colDef?.filter !== "agMultiColumnFilter") return undefined;
	const slots = (colDef.filterParams as { filters?: MultiFilterSlot[] } | undefined)?.filters;
	return Array.isArray(slots) && slots.length > 0 ? slots : undefined;
};

const migrateEntry = (entry: unknown, slots: MultiFilterSlot[]): unknown => {
	const setIndex = slots.findIndex((slot) => slot.filter === "agSetColumnFilter");
	const primaryIndex = slots.findIndex((slot) => slot.filter !== "agSetColumnFilter");
	const targetIndex = isSetShaped(entry) && setIndex !== -1 ? setIndex : primaryIndex;
	if (targetIndex === -1) return entry;
	return {
		filterModels: slots.map((_, index) => (index === targetIndex ? entry : null)),
		filterType: "multi"
	};
};

const migrateStoredFilterModel = (
	filterModel: FilterModel | null | undefined,
	columnDefs: ColDef[]
): FilterModel | null | undefined => {
	if (!filterModel) return filterModel;
	const colDefByField = new Map(
		columnDefs.filter((colDef) => typeof colDef.field === "string").map((colDef) => [colDef.field as string, colDef])
	);
	const migrated: FilterModel = {};
	for (const [field, entry] of Object.entries(filterModel)) {
		const slots = multiFilterSlots(colDefByField.get(field));
		migrated[field] = !slots || isAlreadyMultiShaped(entry) ? entry : migrateEntry(entry, slots);
	}
	return migrated;
};

export default migrateStoredFilterModel;
